import * as React from 'react'
import { ReactElement } from 'react'
import { Language } from '../../../config/i18nConfig'
import useLanguages from '../../../hooks/useLanguages'
import I18NCombobox, { I18NComboboxProps } from './I18NCombobox'

export type LanguageComboboxProps = Omit<I18NComboboxProps<Language>, 'entities' | 'idKey'>

export default function LanguageCombobox(props: LanguageComboboxProps): ReactElement {
    const { languages } = useLanguages()

    return (
        <I18NCombobox<Language>
            entities={languages}
            idKey={'alpha'}
            placeholderKey={'base.languagecombobox.placeholder'}
            {...props}
        />
    )
}
